import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  CTGeneralService,
  CtButtonConfiguration,
  CtControlTypes,
  CtFormConfiguration,
  CtModelDatatableOperators,
  CtThemeTypes,
  MAT_RAISED_ACCENT,
  MAT_RAISED_WARN, CtControlService, CtModelService, CtModelConfiguration, CtSelectControlValue, CtSelectControlOptions,
  CtControlValidator,
  CtDatatableContainerFilterValues,
  CtControlConfiguration,
  CtChipsControlOptions,
  CtModelRouteData
} from '@ctsolution/ct-framework';
import { CTMGeneralService } from 'projects/ct-manager/src/app/_core/lib/general.service';
import { CtWebapiGenericResponse, DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { CompanyTypeRouteData } from "../../../../_core/route-data/company-type.route-data";
import { CompanyType } from "../../../../_core/enum/company-type";
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';

@Component({
  selector: 'app-company-edit-form',
  templateUrl: './company-edit-form.component.html',
})
export class CompanyEditFormComponent implements AfterViewInit {

  @Output() onSubmit: EventEmitter<FormGroup | null> = new EventEmitter<FormGroup | null>();
  @Input() isSupplier: boolean = false;
  @Input() isDialog: boolean = false;
  @Input() datatableContainerFilterValues: CtDatatableContainerFilterValues | null = null;
  @Input() parentComponent: any; // Riferimento al componente parent CompanyEditComponent

  configuration: CtFormConfiguration;

  cancelButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.cancel")
    .setAction(() => this.CTGeneralService.back())
    .setMatherialOptions(MAT_RAISED_WARN);

  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.handleSubmit())
    .setMatherialOptions(MAT_RAISED_ACCENT);

  // private referenceNameControl = this.generalService.getTextControl({
  //   name: 'ReferenceName',
  // });

  private nameControl = this.generalService.getTextControl({
    name: 'Name',
  }).setLabel("Company.Name");

  private surnameControl = this.generalService.getTextControl({
    name: 'Surname',
  }).setLabel("Company.Surname");

  private fiscalCodeControl = this.generalService.getTextControl({
    name: 'FiscalCode'
  })

  private vatControl = this.generalService.getTextControl({
    name: 'VAT'
  });

  private referenceName = this.generalService.getTextControl({
    name: 'ReferenceName'
  }).setLabel("Company.ReferenceName");

  private paymentMethod = this.generalService.getTextControl({
    name: 'PaymentMethod'
  }).setFlexSpacePercentage(50);

  private isSelfControl = this.controlService.getDefaultConfiguration({
    name: 'IsSelf',
    type: CtControlTypes.ENUMERABLE
  }).setHidden(true).setValue(false);

  private activeControl = this.controlService.getDefaultConfiguration({
    name: 'Active',
    label: 'Abilitato',
    type: CtControlTypes.CHECKBOX

  }).setValue(true)
    .setFlexSpacePercentage(30);

  private NoteControl = this.controlService.getDefaultConfiguration({
    name: 'NoteContent',
    type: CtControlTypes.TEXTAREA,
    required: false,
  })
    .setLabel('Note')
    .setFlexSpacePercentage(100);

  private typeLookup = this.controlService
    .getDefaultConfiguration({
      name: 'Type',
      type: CtControlTypes.ENUMERABLE,
      flexSpacePercentage: 50,
      required: true
    })
    .configureOptions<CtSelectControlOptions>(options => {

      if (!options) options = CtSelectControlOptions.create();

      options
        .setNullValueEnabled(false)
        .setObjectComparisonFunction((o1, o2) => o1.Oid === o2.Oid)

    })

  private tagControl: CtControlConfiguration = CtControlConfiguration
    .create()
    .setName('Tags')
    .setLabel('TAGCompany')
    .setType(CtControlTypes.CHIPS)
    .setTheme(CtThemeTypes.MATERIAL)
    .setRemoteValueOptionsEndpoint(
      DataRequest
        .create()
        .setUrl(`/Tag/Lookup`)
        .setMethod(MethodEnum.POST)
        .setBody(CtModelDatatableOperators.create()))
    .configureOptions<CtChipsControlOptions>(options => {

      if (!options) options = CtChipsControlOptions.create();

      options
        .setOnAdd((event: string) => new Promise<CtWebapiGenericResponse<number | string> | null>((resolve) => {

          const controller = 'tag';

          const routeData = CtModelRouteData
            .create()
            .setController(controller);

          const configuration = CtModelConfiguration
            .create()
            .setRouteData(routeData)

          this.modelService
            .putInfos(configuration, { content: event })
            ?.subscribe((response: CtWebapiGenericResponse<any>) => resolve(response.Result))

        }));


    }).setFlexSpacePercentage(50);

  private privateControls = [
    this.typeLookup,
    this.nameControl,
    this.surnameControl,
    this.fiscalCodeControl,
    this.isSelfControl,
    this.NoteControl,
    this.tagControl,
    this.paymentMethod,
    this.activeControl,
  ];

  private businessControls = [
    this.typeLookup,
    this.referenceName,
    this.vatControl,
    this.fiscalCodeControl,
    this.nameControl,
    this.surnameControl,
    this.isSelfControl,
    this.NoteControl,
    this.tagControl,
    this.paymentMethod,
    this.activeControl
  ];

  constructor(
    private CTGeneralService: CTGeneralService,
    private controlService: CtControlService,
    private generalService: CTMGeneralService,
    private modelService: CtModelService<any>,
    private formBuilder: FormBuilder,
    private managerService: CtManagerService,
    private cdr: ChangeDetectorRef) {

    this.configuration = CtFormConfiguration
      .create(this.formBuilder.group({}))
      .setTheme(CtThemeTypes.MATERIAL)
      .setControls(this.privateControls);

    this.setupCompanyTypes();


  }

  async ngAfterViewInit() {

    this.typeLookup
      .control
      ?.valueChanges
      .subscribe(value => {
        switch (value.Type) {

          case CompanyType.Private:

            this.configuration.setControls(this.privateControls)
            this.referenceName.setValidators([]);
            this.surnameControl.setValidators([CtControlValidator.create({ name: "required" } as CtControlValidator)]);
            this.cdr.detectChanges();

            break;

          case CompanyType.Business:

            this.configuration.setControls(this.businessControls)
            this.referenceName.setValidators([CtControlValidator.create().setName('required')]);
            this.surnameControl.setValidators([]);
            this.cdr.detectChanges();

            break;

        }

      })


  }

  setup<T>(value: T | null) {

    if (!value) return;

    this.configuration.form?.patchValue(value);

    const form: any = value;

    if (form.Tags?.length) {

      const tagsValue: CtSelectControlValue[] = [];

      form.Tags.forEach((tag: { Content: string | null; Oid: any; }) => {

        tagsValue.push(CtSelectControlValue.create().setLabel(tag.Content).setValue(tag.Oid))
      });

      setTimeout(() => {
        (<CtChipsControlOptions>this.tagControl.options)?.notifyValuesUpdated(tagsValue);

      }, 500);

    }

  }

  private setupCompanyTypes() {

    const configuration: CtModelConfiguration<any> = CtModelConfiguration.create().setRouteData(CompanyTypeRouteData())
    const body: CtModelDatatableOperators = CtModelDatatableOperators.create();

    this.modelService
      .getList(configuration, body)
      .subscribe(async (response: CtWebapiGenericResponse<any>) => {

        const datasource = response?.Result?.DataSource ?? [];

        const valueOptionsTypeLookup: CtSelectControlValue[] = datasource
          .map((element: any) =>
            CtSelectControlValue
              .create()
              .setLabel(element.Name).setValue(element))

        this.typeLookup.setValueOptions(valueOptionsTypeLookup);

        if (!this.typeLookup.control?.value) {

          const cmpnType: CTConfigurationModel = CTConfigurationModel.create().setType(CompanyType.Private)

          await this.managerService.getComponentOverride("company", "companyType", cmpnType).then((component) => {
            return;
          });

          // Selezione del default del lookup "Tipologia cliente":
          // - se il client ha richiesto `useDefaultCompanyType`, si prende l'elemento marcato
          //   come Default a DB (colonna `Default` della tabella CompanyType);
          // - altrimenti si mantiene il comportamento storico basato sul macro-tipo
          //   (Private/Business). I fornitori (`isSupplier`) restano sempre forzati a Business.
          const defaultValue = (cmpnType.useDefaultCompanyType && !this.isSupplier)
            ? datasource.find((elm: any) => !!elm.Default)
            : datasource.find((elm: any) => elm.Type === (this.isSupplier ? CompanyType.Business : cmpnType.type));

          if (defaultValue) {

            this.typeLookup
              .setValue(defaultValue);

          }

        }

        const typeValue = this.getValueFilterType();

        if (typeValue) {

          const defaultValue = datasource.find((elm: any) => elm.Type === +typeValue)

          if (defaultValue) {

            this.typeLookup
              .setValue(defaultValue);

            this.typeLookup.setDisabled(true);

            //Per Waddi serve non dare la possibilità di creare una company di tipo privato se viene filtrata dalla query
          }


        }

      })

  }

  getValueFilterType(): string | null {

    let value: string | null = null;

    if (this.datatableContainerFilterValues) {

      value = this.datatableContainerFilterValues.constants.find((item) => item.Field === 'Type.Type')?.Value

    }

    return value

  }

  /**
   * Gestisce il click sul pulsante "Salva"
   * Se siamo in modalità edit (con parentComponent disponibile), chiama il submit sincronizzato
   * Altrimenti, emette l'evento per il submit tradizionale
   */
  handleSubmit(): void {
    // Controlla se siamo in modalità edit verificando se esiste un id nel route
    const isEditMode = this.parentComponent?.route?.snapshot?.paramMap?.get('id');
    
    // Se abbiamo il parent component, siamo in edit mode E il metodo submitAll esiste, usa il submit sincronizzato
    if (this.parentComponent && this.parentComponent.submitAll && isEditMode) {
      this.parentComponent.submitAll();
    } else {
      // Altrimenti usa il metodo tradizionale (per create o dialog)
      this.onSubmit.emit(this.configuration.form);
    }
  }

  // private readonly ALLOWED_CONTROLS = {
  //   private: [
  //     'typeLookup', 'nameControl', 'surnameControl', 'fiscalCodeControl',
  //     'isSelfControl', 'NoteControl', 'tagControl', 'activeControl', 'PaymentMethod'
  //   ],
  //   business: [
  //     'typeLookup', 'referenceName', 'vatControl', 'fiscalCodeControl',
  //     'nameControl', 'surnameControl', 'isSelfControl', 'NoteControl',
  //     'tagControl', 'activeControl', 'PaymentMethod'
  //   ]
  // };

  // private async syncMissingControls(controlType: 'private' | 'business'): Promise<void> {
  //   const targetControls = controlType === 'private' ? this.privateControls : this.businessControls;
  //   const allowedNames = this.ALLOWED_CONTROLS[controlType];

  //   const existingFields = new Set(targetControls.map(ctrl => ctrl.name));

  //   const configuration = await this.generalService.getFormConfiguration(
  //     this.formBuilder.group({}),
  //     CompanyRouteData()
  //   );

  //   const missing = configuration.controls?.filter(fc =>
  //     !existingFields.has(fc.name) && allowedNames.includes(fc.name!)
  //   );

  //   if (missing?.length) {
  //     targetControls.push(...missing);
  //   }

  //   //this.configuration.setControls(targetControls);
  //   this.cdr.detectChanges();
  // }

}

